export default __webpack_public_path__ + "static/media/WOR-accessibility.60fa2ab0.png";